<template>
  <div v-if="device.serialnumber" class="container advancedSettings">
    <h1 class="title">
      <span class="icon clickable returnIcon" @click="goBack">
        <i class="mdi mdi-chevron-left"></i>
      </span>
      {{ device.data.name }}
    </h1>

    <h2 class="subtitle">{{ $t("device.information") }}</h2>

    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("device.data.name") }}</label>
          <div class="input">
            <label>{{ device.data.name }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("device.serialnumber") }}</label>
          <div class="input">
            <label>{{ device.serialnumber }}</label>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("device.firmware") }}</label>
          <div class="input">
            <label>{{
              device.firmware.firmware_version_device.replace(/_/g, ".")
            }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{
            $t("device.data.last_sync_datetime_device")
          }}</label>
          <div class="input">
            <label>{{
              moment(device.data.last_sync_datetime_device).format(
                "dddd, D MMMM  YYYY, h:mm:ss a"
              )
            }}</label>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{
            $t("device.data.last_sync_datetime_app")
          }}</label>
          <div class="input">
            <label>{{
              moment(device.data.last_sync_datetime_app).format(
                "dddd, D MMMM  YYYY, h:mm:ss a"
              )
            }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("device.data.nominal_power") }}</label>
          <div class="input">
            <label>{{ device.data.nominal_power }} W</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment-timezone";

export default {
  name: "device-info",
  data() {
    return {};
  },
  computed: {
    ...mapState("installations", {
      installation: "current",
    }),

    ...mapState("zones", {
      zone: "current",
    }),

    ...mapState("devices", {
      device: "current",
    }),
  },
  methods: {
    goBack: function () {
      this.$router.push(
        "/installations/" +
          this.installation[".key"] +
          "/zone/" +
          this.zone.path.split("/")[this.zone.path.split("/").length - 1] +
          "/device/" +
          this.device.serialnumber
      );
    },

    ...mapActions("installations", {
      setInstallation: "setCurrent",
    }),

    ...mapActions("zones", {
      setZone: "setCurrent",
    }),

    ...mapActions("devices", {
      setDevice: "setCurrent",
    }),
  },

  mounted() {
    this.setInstallation(this.$route.params.id)
      .then(() => {
        this.setZone(this.$route.params.idZone).then(() =>
          this.setDevice(this.$route.params.idDevice)
        );
      })
      .catch(() => {
        this.$router.push("/installations");
      });
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 100%;
}
.advancedSettings {
  padding: 0 2rem 2rem;
}

h1.title {
  margin: 3rem 0 5rem;
}

.advancedSettings .columns {
  border-radius: 0;
}
.advancedSettings .columns:nth-child(3) {
  border-radius: 15px 15px 0 0;
}
.advancedSettings .columns:last-child {
  border-radius: 0 0 15px 15px;
}

div.input {
  padding: 5px;
  background-color: white;
  border: 1px solid #dbdbdb;
  color: #363636;
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  border-radius: 4px;

  label {
    cursor: auto;
  }
}
</style>
